export const Configs = {
  forgeRock: {
    url: process.env.REACT_APP_FORGE_ROCK_URL,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
    clientId: process.env.REACT_APP_CLIENT_ID,
    realmPath: process.env.REACT_APP_REALM_PATH,
  },
  e2eTestsUrl: process.env.REACT_APP_E2E_TESTS_URL,
  e2eTestsUrlWithCredentials: process.env.REACT_APP_E2E_TESTS_URL_WITH_CREDENTIALS,
  pipeBasketQuantityEndpoint: process.env.REACT_APP_BASKET_QUANTITY_ENDPOINT,
  pipeMessagesEndpoint: process.env.REACT_APP_MESSAGES_ENDPOINT,
  basketUrl: process.env.REACT_APP_BASKET_URL,
  authorizationUrl: process.env.REACT_APP_AUTHORIZATION_URL,
  addressesSearchUrl: process.env.REACT_APP_ADDRESSES_SEARCH_URL,
  zipCodeSearchUrl: process.env.REACT_APP_ZIP_CODE_SEARCH_URL,
  addressValidationUrl: process.env.REACT_APP_ADDRESS_VALIDATION_URL,
  tracking: {
    adobeAnalyticsScript: process.env.REACT_APP_ADOBE_ANALYTICS_SCRIPT,
    oneTrust: {
      script: process.env.REACT_APP_ONE_TRUST_SCRIPT,
      domain: process.env.REACT_APP_ONE_TRUST_DOMAIN,
    },
    adobeAnalyticsUrl: process.env.REACT_APP_ADOBE_ANALYTICS_URL,
    adobeCloudExperienceUrl: process.env.REACT_APP_ADOBE_CLOUD_EXPERIENCE_URL,
    kameleoonScript: process.env.REACT_APP_KAMELEOON_SCRIPT,
  },
};
